import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Icon, Menu } from 'antd';
import { Link } from 'react-router-dom';
import CommissionMenu from './CommissionMenu';
import CustomScrollbars from 'util/CustomScrollbars';
import SidebarLogo from './SidebarLogo';

import Auxiliary from 'util/Auxiliary';
import UserProfile from './UserProfile';
import {
    NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR,
    NAV_STYLE_NO_HEADER_MINI_SIDEBAR,
    THEME_TYPE_LITE
} from '../../constants/ThemeSetting';

import {
    MENU,
    SUBSCRIPTION_VISIBLE,
    PAGE_PERMISSION,
    USER_TYPES,
    RENTAL_VISIBLE,
    TASK_MODULE_VISIBLE,
    STAFF_VISIBLE,
    COMMUNITY_MODE_VISIBLE,
    FRANCHISEE_VISIBLE,
    CLIENT_VISIBLE,
    IS_LONG_TERM_RENTAL_ENABLE,
    IS_ONLY_LONG_TERM_RENTAL,
    IS_LONG_TERM_THEME,
    IS_LOCATION_BANNER_MODULE_ENABLE,
    IS_CAMPAIGN_NOTIFICATION_ENABLE
} from '../../constants/Common';

import { ReactComponent as Analtytics } from '../../assets/svg/analytics.svg';
import { ReactComponent as Contact } from '../../assets/svg/contact.svg';
import { ReactComponent as Dashboard } from '../../assets/svg/dashboard.svg';
import { ReactComponent as Users } from '../../assets/svg/users.svg';
import { ReactComponent as Customer } from '../../assets/svg/customer.svg';
import { ReactComponent as Dispute } from '../../assets/svg/dispute.svg';
import { ReactComponent as Heatmap } from '../../assets/svg/heatMap.svg';
import { ReactComponent as Notifications } from '../../assets/svg/notifications.svg';
import { ReactComponent as CampaignBell } from '../../assets/svg/notification.svg';
import { ReactComponent as Payment } from '../../assets/svg/payment.svg';
import { ReactComponent as Vehicle } from '../../assets/svg/vehicle.svg';
import { ReactComponent as Partner } from '../../assets/svg/logo.svg';
import { ReactComponent as Bicycle } from '../../assets/svg/bicycle.svg';
import { ReactComponent as GeoLocation } from '../../assets/svg/geoLocation.svg';
import { ReactComponent as Promotions } from '../../assets/svg/promotions.svg';
import { ReactComponent as TC_Module } from '../../assets/svg/t&cModule.svg';
import { ReactComponent as Feedback } from '../../assets/svg/feedback.svg';
import { ReactComponent as AboutUs } from '../../assets/svg/aboutUS.svg';
import { ReactComponent as PrivacyPolicy } from '../../assets/svg/privacyPolicy.svg';
import { ReactComponent as TermsConditionModule } from '../../assets/svg/termsConditionModule.svg';
import { ReactComponent as Support } from '../../assets/svg/servicesRequest.svg';
import { ReactComponent as GeneralSettings } from '../../assets/svg/generalSettings.svg';
import { ReactComponent as Stripefees } from '../../assets/svg/stripefees.svg';
import { ReactComponent as Analytics } from '../../assets/svg/analytics.svg';
import { ReactComponent as Address } from '../../assets/svg/location.svg';
import { ReactComponent as SubscriptionPass } from '../../assets/svg/subscription-pass.svg';
import { ReactComponent as UserDue } from '../../assets/svg/userDue.svg';
import { ReactComponent as Advertisement } from '../../assets/svg/advertisement.svg';

import RentalMenu from './RentalMenu';
import TaskMenu from './TaskMenu';
import CommunityMenu from './CommunityMenu';

const _ = require('lodash');

class SidebarContent extends Component {

    components = {
        Vehicle: Vehicle,
        Analtytics: Analtytics,
        Dashboard: Dashboard,
        Dispute: Dispute,
        Notifications: Notifications,
        CampaignBell: CampaignBell,
        Payment: Payment,
        Heatmap: Heatmap,
        Contact: Contact,
        Partner: Partner,
        Bicycle: Bicycle,
        Customer: Customer,
        Users: Users,
        GeoLocation: GeoLocation,
        Promotions: Promotions,
        TC_Module: TC_Module,
        Feedback: Feedback,
        AboutUs: AboutUs,
        PrivacyPolicy: PrivacyPolicy,
        TermsConditionModule: TermsConditionModule,
        Support: Support,
        GeneralSettings: GeneralSettings,
        Stripefees: Stripefees,
        Analytics: Analytics,
        Address: Address,
        SubscriptionPass: SubscriptionPass,
        UserDue: UserDue,
        Advertisement: Advertisement
    }

    getNoHeaderClass = (navStyle) => {
        if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR || navStyle === NAV_STYLE_NO_HEADER_EXPANDED_SIDEBAR) {
            return 'gx-no-header-notifications';
        }

        return '';
    };

    getNavStyleSubMenuClass = (navStyle) => {
        if (navStyle === NAV_STYLE_NO_HEADER_MINI_SIDEBAR) {
            return 'gx-no-header-submenu-popup';
        }

        return '';
    };

    getActiveMenuStyle = (path) => {
        const updatedPathArray = path.split('/');
        const updatedPath = '/' + updatedPathArray[1] + '/' + updatedPathArray[2] + '/';
        let currentPath = window.location.pathname;
        const updatedCurrentPathArray = currentPath.split('/');
        const updatedCurrentPath = '/' + updatedCurrentPathArray[1] + '/' + updatedCurrentPathArray[2] + '/';
        if (updatedCurrentPath.includes(updatedPath)) {
            return 'active-menu-escooter';
        }

        return '';

    }

    returnSvg = (svg) => {
        const Tag = this.components[svg];

        return <Tag />;
    }

    render() {
        const { pathname, navStyle, themeType, auth } = this.props;
        let sidebarMenu = MENU;
        if (!auth || !auth.authUser) {
            return true;
        }

        if (SUBSCRIPTION_VISIBLE === false) {
            sidebarMenu = sidebarMenu.filter(el => el.id !== PAGE_PERMISSION.SUBSCRIPTION);
        }
        if (RENTAL_VISIBLE === false) {
            sidebarMenu = sidebarMenu.filter(el => el.id !== PAGE_PERMISSION.RENTAL)
        }
        if(IS_LOCATION_BANNER_MODULE_ENABLE === false) {
            sidebarMenu = sidebarMenu.filter(el => el.id !== PAGE_PERMISSION.LOCATION_BANNER)
        }
        if (IS_CAMPAIGN_NOTIFICATION_ENABLE === false) {
            sidebarMenu = sidebarMenu.filter(el => el.id !== PAGE_PERMISSION.CAMPAIGN_NOTIFICATION)
        }
        if ((IS_LONG_TERM_RENTAL_ENABLE === false) && (IS_ONLY_LONG_TERM_RENTAL === false)) {
            sidebarMenu = sidebarMenu.filter(el => el.id !== PAGE_PERMISSION.VEHICLE_MODELS)
            sidebarMenu = sidebarMenu.filter(el => el.id !== PAGE_PERMISSION.RENTAL_PLAN)
            sidebarMenu = sidebarMenu.filter(el => el.id !== PAGE_PERMISSION.ORDER)
            sidebarMenu = sidebarMenu.filter(el => el.id !== PAGE_PERMISSION.ADDRESS)
            sidebarMenu = sidebarMenu.filter(el => el.id !== PAGE_PERMISSION.PAYMENT_ADVICE_NOTE);
            sidebarMenu = sidebarMenu.filter(el => el.id !== PAGE_PERMISSION.USER_DUES);
        } else if ((USER_TYPES.FRANCHISEE !== auth.authUser.type) && (USER_TYPES.DEALER !== auth.authUser.type)) {
            sidebarMenu = sidebarMenu.filter(el => el.id !== PAGE_PERMISSION.PAYMENT_ADVICE_NOTE);
            sidebarMenu = sidebarMenu.filter(el => el.id !== PAGE_PERMISSION.USER_DUES);
        }
        if (TASK_MODULE_VISIBLE === false) {
            sidebarMenu = sidebarMenu.filter(el => el.id !== PAGE_PERMISSION.TASKSETUP);
        }
        if (COMMUNITY_MODE_VISIBLE === false) {
            sidebarMenu = sidebarMenu.filter(el => el.id !== PAGE_PERMISSION.COMMUNITY_MODE);
        }
        if (auth.authUser.type === USER_TYPES.FRANCHISEE || auth.authUser.type === USER_TYPES.DEALER) {
            if (!STAFF_VISIBLE) {
                sidebarMenu = sidebarMenu.filter(el => el.id !== PAGE_PERMISSION.USERS);
            }/* else {
                let index = _.findIndex(sidebarMenu, { id: PAGE_PERMISSION.USERS });
                sidebarMenu[index].name = "Staff"
            }*/
        }
        let franchiseeTabs = [
            PAGE_PERMISSION.SERVICE_REQUEST,
            PAGE_PERMISSION.COMMISSION,
            PAGE_PERMISSION.COMMISSION_PAYOUT,
            PAGE_PERMISSION.COMMISSION_REPORT,
            PAGE_PERMISSION.LOCATION,
            PAGE_PERMISSION.FRANCHISEE,
            PAGE_PERMISSION.RENTAL,
            PAGE_PERMISSION.RENTAL_PAYMENT,
            PAGE_PERMISSION.RENTAL_PAYMENT_CLIENT
        ]
        if (FRANCHISEE_VISIBLE === false) {
            sidebarMenu = sidebarMenu.filter(el => !franchiseeTabs.includes(el.id));
        }
        if (CLIENT_VISIBLE === false) {
            sidebarMenu = sidebarMenu.filter(el => el.id !== PAGE_PERMISSION.DEALER);
        }
        let menuPermission = auth.authUser.accessPermission;
        const selectedKeys = pathname.substr(1);
        const defaultOpenKeys = selectedKeys.split('/')[1];
        // let loginUserType = 1;
        // if (auth && auth.authUser && auth.authUser.type) {
        //     loginUserType = auth.authUser.type;
        // }

        return (
            <Auxiliary>
                <div>
                    <SidebarLogo />
                </div>
                <div className="gx-sidebar-content">
                    <div className={`gx-sidebar-notifications ${this.getNoHeaderClass(navStyle)}`}>
                        <UserProfile pathname={pathname} />
                        {/* <AppsNavigation /> */}
                    </div>
                    <CustomScrollbars className="gx-layout-sider-scrollbar">
                        <Menu
                            defaultOpenKeys={[defaultOpenKeys]}
                            selectedKeys={[selectedKeys]}
                            theme={themeType === THEME_TYPE_LITE ? 'lite' : 'dark'}
                            mode="inline"
                        >
                            {
                                sidebarMenu.map((menu) => {
                                    let indexes = _.findIndex(menuPermission, { module: menu.id });
                                    let hasPermission = menuPermission[indexes] && menuPermission[indexes].permissions &&
                                        menuPermission[indexes].permissions.list;
                                    return hasPermission ?
                                        menu.id === PAGE_PERMISSION.TASKSETUP ?
                                            <TaskMenu pathname={pathname} menu={menu} key={menu.id} />
                                            :
                                            menu.id === PAGE_PERMISSION.RENTAL && FRANCHISEE_VISIBLE ?
                                                <RentalMenu pathname={pathname} menu={menu} key={menu.id} />
                                                :
                                                menu.id === PAGE_PERMISSION.COMMUNITY_MODE ?
                                                    <CommunityMenu pathname={pathname} menu={menu} key={menu.id} />
                                                    :
                                                    menu.id === PAGE_PERMISSION.COMMISSION && FRANCHISEE_VISIBLE ?
                                                        <CommissionMenu pathname={pathname} menu={menu} key={menu.id} />
                                                        :
                                                        <Menu.Item key={menu.id} className={this.getActiveMenuStyle(menu.path)}>
                                                            <Link to={menu.path ? menu.path : ''}>
                                                                {
                                                                    IS_LONG_TERM_THEME ?
                                                                        menu.svg ?
                                                                            <i>
                                                                                <div className='newSideBar'>
                                                                                    {this.returnSvg(menu.svg)}
                                                                                    {menu.isCountVisible ? (
                                                                                        <>
                                                                                            <span style={{ width: '63%' }}>{menu.name}</span>
                                                                                            < span class="numbers-count">{menu?.count ?? 0}</span>
                                                                                        </>
                                                                                    ) : (
                                                                                        <span>{menu.name}</span>
                                                                                    )}
                                                                                </div>
                                                                            </i> : <>
                                                                                <div className='newSideBar'>
                                                                                    <Icon type={menu.icon} />
                                                                                    <span>{menu.name}</span>
                                                                                </div>
                                                                            </>
                                                                        : menu.svg ?
                                                                            <div className="sidebar-container-item">
                                                                                <div className="main-container">
                                                                                    <div>
                                                                                        <i className="anticon"> {this.returnSvg(menu.svg)}</i>
                                                                                    </div>
                                                                                    {menu.isCountVisible &&
                                                                                        <div className="container">
                                                                                            <span class="numbers-count">{menu?.count ?? 0}</span>
                                                                                        </div>
                                                                                    }
                                                                                </div>
                                                                                <span className="text-label">{menu.name}</span>
                                                                            </div>
                                                                            : <>
                                                                                <Icon type={menu.icon} /> <span>{menu.name}</span>
                                                                            </>
                                                                }
                                                            </Link>
                                                        </Menu.Item>
                                        : '';
                                })
                            }
                        </Menu>
                    </CustomScrollbars>
                </div>
            </Auxiliary >
        );
    }
}

SidebarContent.propTypes = {};
const mapStateToProps = ({ auth, settings }) => {
    const { navStyle, themeType, locale, pathname } = settings;

    return { navStyle, themeType, locale, pathname, auth };
};

export default connect(mapStateToProps)(SidebarContent);
